import * as ActionTypes from './types';

export function changePillarsState(payload) {
    return {
        type: ActionTypes.CHANGE_PILLARS_STATE,
        payload: payload
    }
}

export function getPillars(payload) {
  return {
    type: ActionTypes.GET_PILLARS,
    payload: payload
  }
}

export function getPillarsSuccess(payload) {
  return {
    type: ActionTypes.GET_PILLARS_SUCCESS,
    payload: payload
  }
}

export function getPillarsFailed(payload) {
  return {
    type: ActionTypes.GET_PILLARS_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/pillars.js